<template>
  <SvgIcon style="width:1em;height:1em" icon="12-Filled-PullUp" />
</template>
